var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCurate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 687.25 660.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.79,660.48C150.78,660.48,0,512.63,0,330.24S150.78,0,336.79,0",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.25,312.72c-171.72,0-310.92-139.2-310.92-310.92h310.92v310.92Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.62,
    y: 352.26,
    width: 308.63,
    height: 308.63,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCurate);
export default __webpack_public_path__ + "static/media/IconCurate.9ba2efe652080d6e2925ee7afe69696c.svg";
export { ForwardRef as ReactComponent };